import { Dropdown } from "antd"
import PropTypes from "prop-types"
import MoreActionEllipsis from "ui/MoreActionEllipsis"
import { Text } from "ui/Typography"
import TimeOffNotFound from "../TimeOffNotFound"
import { getTimeOffColumns, TIME_OFF_BE_KEYS } from "pagesV2/pro/Calendar/constants"
import styles from "../index.module.css"
import { useDevice } from "hooks/useDevice"

const TimeOffRange = ({ timeOff, getDropdownItems }) => {
  const columns = getTimeOffColumns(TIME_OFF_BE_KEYS.dateRange);
  const { isMobile } = useDevice();
  if (!timeOff?.length) {
    return <TimeOffNotFound type="date range" colSpan={columns.length} />;
  }
  return (
    <tbody>
      {timeOff?.map((item) => {
        const { id, start_time, end_time, start_date, end_date, recurring_yearly } = item || {};
        return (
          <tr key={id}>
            <td data-label={columns[0]}>
              <Text>
                {start_date}, {start_time}
              </Text>
            </td>
            <td data-label={columns[1]}>
              <Text>
                {end_date}, {end_time}
              </Text>
            </td>
            <td data-label={columns[2]}>
              <Text>{recurring_yearly ? "Yes" : "No"}</Text>
            </td>
            <td data-label={columns[3]} className={styles.actionColumn}>
              <Dropdown trigger={["click"]} placement="bottomRight" menu={{ items: getDropdownItems(item) }}>
                {isMobile ? <Text className={styles.moreText}> More actions</Text> : <MoreActionEllipsis />}
              </Dropdown>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

TimeOffRange.propTypes = {
  timeOff: PropTypes.array,
  getDropdownItems: PropTypes.func
}

export default TimeOffRange
